<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="UID">
                <el-input v-model="searchData.user_id" size="mini" />
            </el-form-item>
            <el-form-item label="活动提现状态">
                <el-select v-model="searchData.status" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, index) in statusOpt"
                        :key="index"
                        :label="opt.desc"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="datalist">
            <el-table-column prop="id" label="提现ID"/>
            <el-table-column prop="user_id" label="用户ID"/>
            <el-table-column label="活动状态">
                <template slot-scope="scope">
                    <span>{{ getStatus(scope.row.status) }}</span>
                </template>
            </el-table-column>

            <el-table-column label="金额奖励(元)">
                <template slot-scope="scope">
                    <span>{{ formatterMoney(scope.row.amount) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提现金额(元)">
                <template slot-scope="scope">
                    <span>{{ formatterMoney(scope.row.amount_withdraw) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="税费(元)">
                <template slot-scope="scope">
                    <span>{{ formatterMoney(scope.row.amount_tax) }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="提现开始年月">
                <template slot-scope="scope">
                    <span>{{ forMatter(scope.row.start_year_time) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提现结束年月">
                <template slot-scope="scope">
                    <span>{{ forMatter(scope.row.end_year_time) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提现发起时间">
                <template slot-scope="scope">
                    <span>{{ forMatter(scope.row.withdraw_apply_time) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提现完成时间">
                <template slot-scope="scope">
                    <span>{{ forMatter(scope.row.withdraw_finish_time) }}</span>
                </template>
            </el-table-column>
            
            
            <el-table-column
                label="操作"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleShowDialog(scope.row)"
                        v-if="scope.row.status !== 1"
                    >查看</el-button>
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleShowDialog(scope.row)"
                        v-else
                    >编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="50"
            :pageSizes="pageSizes"
            :currentPageCount="datalist.length"
            @page-changed="loadData"
        ></page-bar>
        <el-dialog :visible.sync="dialogShow">
            <el-form label-position="right">
                <el-form-item label="提现ID：" label-width="150px">
                    <el-input v-model="detail.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="用户ID：" label-width="150px">
                    <el-input v-model="detail.user_id" disabled></el-input>
                </el-form-item>
                
                <el-form-item label="实名认证类型：" label-width="150px">
                    <el-input :value="forMatterUserType(userCertificateInfo.type)" disabled></el-input>
                </el-form-item>
                <el-form-item label="实名认证状态：" label-width="150px">
                    <el-input :value="forMatterUserStatus(userCertificateInfo.status)" disabled></el-input>
                </el-form-item>
                <el-form-item label="姓名：" label-width="150px">
                    <el-input v-model="userCertificateInfo.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" label-width="150px">
                    <el-input v-model="userCertificateInfo.id_card" disabled></el-input>
                </el-form-item>
                
                <el-form-item label="活动提现状态：" label-width="150px">
                    <el-input :value="getStatus(detail.status)" disabled></el-input>
                </el-form-item>
                <el-form-item label="奖励金额(元)：" label-width="150px">
                    <el-input :value="formatterMoney(detail.amount)" disabled></el-input>
                </el-form-item>
                <el-form-item label="提现金额(元)：" label-width="150px">
                    <el-input :value="formatterMoney(detail.amount_withdraw)" disabled class="redTxt"></el-input>
                </el-form-item>
                <el-form-item label="税费(元)：" label-width="150px">
                    <el-input :value="formatterMoney(detail.amount_tax)" disabled></el-input>
                </el-form-item>
                <el-form-item label="提现开始年月：" label-width="150px">
                    <el-input :value="forMatter(detail.start_year_time)" disabled></el-input>
                </el-form-item>
                <el-form-item label="提现结束年月：" label-width="150px">
                    <el-input :value="forMatter(detail.end_year_time)" disabled></el-input>
                </el-form-item>
                <el-form-item label="提现发起时间：" label-width="150px">
                    <el-input :value="forMatter(detail.withdraw_apply_time)" disabled></el-input>
                </el-form-item>
                <el-form-item label="提现完成时间：" label-width="150px">
                    <el-input :value="forMatter(detail.withdraw_finish_time)" disabled></el-input>
                </el-form-item>
                
                <el-form-item label="提现详情：" label-width="150px">
                    <div v-for="(amountItem, index) in amount_withdraw_monthly_sum" :key="index" class="amountItem" >
                        <el-input v-model="amountItem.effective_year_month" disabled></el-input>
                        <el-input :value="formatterMoney(amountItem.amount_withdraw)" disabled></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="提现相关结算记录：" label-width="150px">
                    <el-button type="info" size="small" @click="recordDialogVisible = !recordDialogVisible">查看结算记录</el-button>
                </el-form-item>
                <el-form-item label="打款银行：" label-width="150px">
                    <el-input v-model="user_finance_config.opening_bank" disabled></el-input>
                </el-form-item>
                <el-form-item label="分行信息：" label-width="150px">
                    <el-input v-model="user_finance_config.opening_bank_detail" disabled></el-input>
                </el-form-item>
                <el-form-item label="打款账号：" label-width="150px">
                    <el-input v-model="user_finance_config.bank_card_id" disabled></el-input>
                </el-form-item>
                <el-form-item label="账户名：" label-width="150px">
                    <el-input v-model="user_finance_config.bank_account_name" disabled></el-input>
                </el-form-item>

                <el-form-item label="处理：" label-width="150px">
                    <el-select v-model="verify" :disabled="detail.status !== 1">
                        <el-option
                            v-for="item in verifyList"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="失败原因：" v-if="!verify" label-width="150px">
                    <el-select v-model="extra.fatal_reason" :disabled="detail.status === 3">
                        <el-option
                            v-for="item in failReasonList"
                            :key="item"
                            :label="item"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="打款流水号：" label-width="150px" v-if="verify">
                    <el-input v-model="extra.payment_transaction_id" :disabled="detail.status === 2"></el-input>
                </el-form-item>
                <el-form-item label="打款金额(元)：" label-width="150px" v-if="verify">
                    <el-input :value="formatterMoney(extra.payment_amount)" disabled v-if="detail.status === 2"></el-input>
                    <el-input v-model="extra.payment_amount" :disabled="detail.status === 2" v-else></el-input>
                </el-form-item>
                <el-form-item label="发票号：" label-width="150px" v-if="verify">
                    <el-input v-model="extra.payment_invoice_number" :disabled="detail.status === 2"></el-input>
                    <span style="color: red;">*企业用户需要填写</span>
                </el-form-item>

                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                    <el-button type="info" size="small" @click="dialogShow = !dialogShow">取消</el-button>
                    <el-button type="primary" size="small" @click="handleClickAudit">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确认此次审核吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="recordDialogVisible"
            width="70%"
            :before-close="handleRecordDialogClose">
            <el-table :data="settlement_records">
                <el-table-column prop="id" label="结算记录ID"/>
                <el-table-column prop="source_user_id" label="奖励来源用户ID"/>
                <el-table-column prop="source_order_id" label="奖励来源订单号"/>
                <el-table-column prop="activity_name" label="活动名称"/>
                <el-table-column label="金额奖励(元)">
                    <template slot-scope="scope">
                        <span>{{ formatterMoney(scope.row.amount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="提现金额(元)">
                    <template slot-scope="scope">
                        <span>{{ formatterMoney(scope.row.amount_withdraw) }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="结算记录生效时间">
                    <template slot-scope="scope">
                        <span>{{ forMatter(scope.row.effective_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"/>
                
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="recordDialogVisible  = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/api/request.js'
import PageBar from '../ui/PageBar'
export default {
    components: {
        PageBar
    },
    data(){
        return {
            searchData: {},
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            dialogShow: false,
            dialogVisible: false,
            recordDialogVisible: false,
            datalist: [],
            listItem: {},
            detail: {},
            user_finance_config: {},
            extra: {}, //用户财务配置信息	
            amount_withdraw_monthly_sum: [], //各月份提现金额	
            settlement_records: [], //提现相关结算记录	
            statusOptions: ['提现中',  '提现成功', '提现失败'],
            typeOptions: ['未认证',  '个人用户', '企业用户'],
            statusOpt: [{value: 999, desc: '全部'},{value: 1, desc: '提现中'},{value: 2, desc: '提现成功'},{value: 3, desc: '提现失败'}],
            commission_rate: null,
            tax_rate: null,
            financeDialogShow: false,
            financeConfig: {},
            verify: true,
            verifyList: [{label: '通过', value: true}, {label: '失败', value: false}],
            failReasonList: [],
            currentWithdrawId: '',
            filter: {},
            userCertificateInfo: {}
        }
    },
    created() {
        this.loadData(this.currentRange)
        this.getFailReason()
    },
    methods: {
        loadData(range){
            this.currentRange = range
            this.datalist = []
            request.saas
                .post('activity/get_activity_withdraw_list', { range: range, filter: this.filter })
                .then(r => {
                    this.datalist = r.data.list
                })
        },
        getFailReason(){
            request.saas.post("activity/get_activity_withdraw_audit_reason_list", {})
                .then(res => this.failReasonList = res.data.list)
        },
        handleClickAudit(){
            if(this.detail.status !== 1) {
                this.dialogShow = !this.dialogShow
                return
            }
            this.dialogVisible = !this.dialogVisible
        },
        handlerSearch() {
            let filter = {}
            if (this.searchData.user_id) {
                filter.user_id = this.searchData.user_id.toString()
            }
            if (this.searchData.status !== 999 && this.searchData.status) {
                filter.status = [this.searchData.status]
            }
            this.filter = filter
            this.loadData(this.currentRange)
        },
        save(){
            let data = {}
            if(this.verify) {
                data = {
                    id: this.currentWithdrawId, //提现记录id
                    status: 2, //提现成功
                    payment_transaction_id: this.extra.payment_transaction_id,
                    payment_amount: this.accMul(this.extra.payment_amount, 100),
                    payment_invoice_number: this.extra.payment_invoice_number,
                }
            } else {
                data = {
                    id: this.currentWithdrawId, //提现记录id
                    status: 3, //提现失败
                    fatal_reason: this.extra.fatal_reason
                }
            }

            console.log(data)
            request.saas
                .post('activity/audit_activity_withdraw', data)
                .then(() => {
                    this.$message.success('审核成功')
                    this.dialogVisible = !this.dialogVisible
                    this.dialogShow = !this.dialogShow
                    this.loadData(this.currentRange)
                })
        },
        accMul(arg1, arg2) {
            var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length;
            }
                // eslint-disable-next-line no-empty
            catch (e) {

            }
            try {
                m += s2.split(".")[1].length;
            }
                // eslint-disable-next-line no-empty
            catch (e) {
            }
            return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
        handleRecordDialogClose(){
            this.recordDialogVisible = !this.recordDialogVisible
        },
        handleShowDialog(item){
            this.listItem = item
            this.currentWithdrawId = item.id
            this.extra = {}
            this.user_finance_config = {}
            this.settlement_records = []
            request.saas
                .post('activity/get_activity_withdraw_detail', {id: this.listItem.id})
                .then(res => {
                    this.detail = res.data
                    this.detail.name = item.name
                    this.detail.type = item.type
                    this.detail.identity = item.identity
                    this.extra = res.data.extra
                    this.user_finance_config = res.data.user_finance_config
                    this.userCertificateInfo = res.data.user_certificate_info
                    this.amount_withdraw_monthly_sum = res.data.activity_amount_withdraw_monthly_sum
                    this.settlement_records = res.data.activity_settlement_records
                    this.verify = this.detail.status !== 3;
                    this.dialogShow = !this.dialogShow
                })
        },
        handleFinanceInfoShowDialog(item){
            request.saas
                .post('uc/settlement/get_user_finance_config', {user_id: item.id})
                .then(res => {
                    this.financeConfig = res.data
                    this.handleFinanceDialogClose()
                })
        },
        handleFinanceDialogClose(){
            this.financeDialogShow = !this.financeDialogShow
        },
        forMatter(time){
            if(!time) {
                return '--'
            }
            return time
        },
        forMatterUserType(type) {
            return type === 1 ? '个人' : '企业'
        },
        forMatterUserStatus(status) {
            let statusArr = ['审核中', '认证成功', '认证失败', '未认证']
            return statusArr[status - 1]
        },
        getType(type){
            return this.typeOptions[type]
        },
        getStatus(status) {
            return this.statusOptions[status-1]
        },
        formatterMoney(money) {
            return (money/100).toFixed(2)
        }
    }
}
</script>
<style scoped>
.amountItem{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
}
.amountItem .el-input{
    margin-left: 20px;
    width: 200px;
}
.redTxt >>> input{
    color: red !important;
    font-weight: 600;
    font-size: 18px;
}
</style>
